/**
 * Class definition for `clover-accordion-content` element
 *
 * @class CloverAccordionContent
 * @extends {HTMLElement}
 */
class CloverAccordionContent extends HTMLElement {
  constructor(self) {
    self = super(self);
    this.setAttribute('role', 'tabpanel');
    this.tabIndex = -1;
    this.collapsed = true;
    this.style.height = 0;
    return self;
  }

  /**
   * Tag name of element
   *
   * @readonly
   * @static
   */
  static get is() {
    return 'clover-accordion-content';
  }

  /**
   * Watched attributes
   *
   * @readonly
   * @static
   */
  static get observedAttributes() {
    return ['collapsed'];
  }

  /**
   * Lifecycle event when watched attribute is changed
   *
   * @param {string} name Attribute name
   * @param {any} oldVal Old value of attribute
   * @param {any} newVal New value of attribute
   */
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'collapsed':
        this._collapsedChanged();
    }
  }

  /**
   * Getter for `collapsed` attribute
   */
  get collapsed() {
    return this.hasAttribute('collapsed');
  }

  /**
   * Setter for `collapsed` attribute
   */
  set collapsed(value) {
    if (Boolean(value)) {
      this.setAttribute('collapsed', '');
    } else {
      this.removeAttribute('collapsed');
    }
  }

  /**
   * Called when `collapsed` attribute is changed
   *
   * @private
   */
  _collapsedChanged() {
    // Set height
    this.style.height = `${this.scrollHeight}px`;

    // If collapsed, set height to 0
    if (this.collapsed) {
      setTimeout(() => {
        this.style.height = 0;

        // Ensure animation has ended
        this._animate().then(() => {
          this.style.height = 0;
        });
      }, 25);
    } else {
      // After animation, reset height so panels can resize accordingly
      this._animate().then(() => {
        this.style.height = null;
      });
    }
  }

  /**
   * Add event listener to ensure transition ends
   *
   * @private
   * @returns {Promise} Resolves when transition ends
   */
  _animate() {
    return new Promise((resolve) => {
      this.$once('transitionend', () => {
        resolve();
      });

      // Resolve promise if transitionend is never called using timeout
      setTimeout(() => {
        resolve();
      }, 500);
    });
  }
}

customElements.define(CloverAccordionContent.is, CloverAccordionContent);
